export * from './app-sidebar.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-sidebar/index.ts